import React from 'react';
import styles from './ConfirmNewPassword.module.scss';

import PrimaryButtonV2 from '../../../components/UI/Buttons/PrimaryButtonV2';
import { useNavigate } from 'react-router-dom';
import { authorizeClient } from '../../../networking/client';
import { useAppDispatch } from '../../../store/store';
import { logout } from '../../../store/slices/auth';
import { useTranslation } from '../../../hooks/useTranslations';

function ConfirmNewPassword() {
  const { translations } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleSubmit = async () => {
    try {
      await authorizeClient.get('/ident/oauth/logout');
      dispatch(logout());
      navigate('/web');
    } catch (_) {}
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.container}>
        <div className={styles.title}>{translations('label.confirmation_of_password')}</div>
        <div className={styles.hint}>{translations('label.our_password_has')}</div>
        <div className={styles.badge} />
        <PrimaryButtonV2
          text={translations('login')}
          containerStyle={{
            width: '100%',
          }}
          buttonStyle={{
            width: '100%',
          }}
          onClick={handleSubmit}
        />
      </div>
    </div>
  );
}

export default ConfirmNewPassword;
